import { render, staticRenderFns } from "./Cardshare.vue?vue&type=template&id=6b95dcf1&scoped=true&"
import script from "./Cardshare.vue?vue&type=script&lang=js&"
export * from "./Cardshare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b95dcf1",
  null
  
)

export default component.exports